import { DOCUMENT, Injectable, inject } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class MetadataService {
    private meta = inject(Meta);
    private titleService = inject(Title);
    private environmentService = inject(EnvironmentService);
    private router = inject(Router);
    private document = inject<Document>(DOCUMENT);

    setColor(colorCode) {
        this.meta.updateTag({ name: 'theme-color', content: colorCode });
    }

    setTitle(pageTitle: string, postfix = '') {
        const title = `${pageTitle}${postfix}`;
        this.titleService.setTitle(title);
        this.setAttribute({ property: 'og:title', content: title });
    }

    setAttribute(data: MetaDefinition) {
        this.meta.updateTag(data);
    }

    setCanonicalUrl(route: string, queryParamsToKeep: string[] = []) {
        const urlTree = this.router.parseUrl(route);
        if (queryParamsToKeep.length > 0) {
            const originalQueryParams = { ...urlTree.queryParams };
            urlTree.queryParams = Object.keys(originalQueryParams)
                .filter(key => queryParamsToKeep.includes(key))
                .reduce((obj, key) => {
                    obj[key] = originalQueryParams[key];
                    return obj;
                }, {});
        } else {
            urlTree.queryParams = {};
        }
        urlTree.fragment = null;
        const url = `${this.environmentService.hostName()}${urlTree.toString()}`;
        const linkElement = this.getCanonicalUrlElement();
        linkElement.setAttribute('href', url);
        this.setAttribute({ property: 'og:url', content: url });
    }

    private getCanonicalUrlElement(): HTMLLinkElement {
        const canonicalLink =
            this.document.getElementById('canonicalUrl') ??
            this.document.querySelector('link[rel="canonical"]');

        if (canonicalLink instanceof HTMLLinkElement) {
            canonicalLink.id = 'canonicalUrl';
            return canonicalLink;
        }

        const linkElement = this.document.createElement('link');
        linkElement.id = 'canonicalUrl';
        linkElement.rel = 'canonical';
        (this.document.head ?? this.document.documentElement).appendChild(
            linkElement
        );

        return linkElement;
    }
}
